module.exports = __webpack_public_path__ + "static/img/Castle.f523268.png";